<template>
  <footer id="foot_guide">
    <div class="logo"></div>
    <div class="companyInfo">
      <div class="contact">
        <div><i class="icon">&#xe612;</i> shangdingyun@126.com</div>
        <div><i class="icon">&#xe662;</i> 广东省深圳市宝安区西乡街道金海路汇潮科技大厦602~603室（西乡地铁B出口往前200米）</div>
        <div><i class="icon">&#xe608;</i> 18026947612</div>
      </div>
      <div class="QRCode">
        <img src="http://qn.kemean.cn/upload/202103/22/1616415154063jvpoq0yk.png">
      </div>
    </div>
    <div class="case">CopyRight © 2021 ShangDingYun Corporation, All Rights Reserved <a href="http://beian.miit.gov.cn" target="_blank">粤ICP备2020113710号</a> 商鼎云技术（深圳）集团有限公司</div>
  </footer>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  created() { },
  mounted() { },
  computed: {
    ...mapState(["geohash"])
  },
  methods: {
    gotoAddress(path) {
      this.$router.push(path);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../style/mixin";
@media screen and (min-width: 750px) {
  #foot_guide {
    @include bis(
      "https://qn.kemean.cn/upload/201809/06/531f9cffe5034b2aab7613b0be788aad"
    );
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-size: 100% 100%;
    padding: 30px 0px;
    .logo {
      width: 170px;
      height: 37px;
      @include bis(
        "http://qn.kemean.cn/upload/202103/22/1616415365768033w93ri.png"
      );
    }
    .companyInfo {
      padding: 30px 0 20px 0;
      display: flex;
      .contact {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        div {
          display: flex;
          align-items: center;
          font-size: 16px;
          color: #888888;
          i {
            color: $mainColor;
            font-size: 23px;
            margin-right: 10px;
          }
        }
      }
      .QRCode {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        margin-left: 10px;
        img {
          width: 80px;
          height: 80px;
        }
        p {
          font-size: 16px;
          color: rgba(255, 255, 255, 0.5);
          margin-top: 10px;
        }
      }
    }
    .case {
      margin-top: 33px;
      text-align: center;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.5);
      a {
        text-decoration: underline;
        color: rgba(255, 255, 255, 0.5);
        &:hover {
          color: $mainColor;
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  #foot_guide {
    @include bis(
      "https://qn.kemean.cn/upload/201809/06/531f9cffe5034b2aab7613b0be788aad"
    );
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-size: auto 100%;
    padding: 5vw 0;
    .logo {
      display: none;
      width: 46vw;
      height: 13vw;
      @include bis("https://qn.kemean.cn/upload/201809/06/logo.png");
    }
    .companyInfo {
      padding: 5vw 3vw 0vw 3vw;
      display: flex;
      .contact {
        display: flex;
        justify-content: space-around;
        flex-direction: column;
        div {
          display: flex;
          align-items: center;
          font-size: 3.6vw;
          color: #888888;
          i {
            color: $mainColor;
            font-size: 5vw;
            margin-right: 2vw;
          }
        }
      }
      .QRCode {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        margin-left: 4vw;
        img {
          width: 80px;
          height: 80px;
        }
        p {
          font-size: 3.4vw;
          color: rgba(255, 255, 255, 0.5);
          margin-top: 2vw;
          white-space: nowrap;
        }
      }
    }
    .case {
      padding: 0px 2vw;
      margin-top: 4vw;
      text-align: center;
      font-size: 3.4vw;
      color: rgba(255, 255, 255, 0.5);
      a {
        text-decoration: underline;
        color: rgba(255, 255, 255, 0.5);
        &:hover {
          color: $mainColor;
        }
      }
    }
  }
}
</style>
